'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _helpers = require('helpers');

var _reactRouter = require('react-router');

var _components2 = require('components');

var _SHARE = require('components/SHARE');

require('./WishListView.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    WishListView: {
        displayName: 'WishListView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/WishList/default/WishListView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var WishListView = _wrapComponent('WishListView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(WishListView, _Component);

    function WishListView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WishListView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WishListView.__proto__ || (0, _getPrototypeOf2.default)(WishListView)).call.apply(_ref, [this].concat(args))), _this), _this.renderProduct = function (item) {
            var currency = _this.props.currency;

            var price = parseFloat(item.price);
            var picture = (0, _helpers.checkPicture)(item.pictures);

            var modifier_option_name = _react3.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-2 prod_desc' },
                _react3.default.createElement('div', { className: 'title' })
            );
            if (item.modifier_option_id !== null && item.modifier_option_id !== undefined) {
                modifier_option_name = _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2 prod_desc' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title' },
                        item.modifier_option.name
                    )
                );
            } else if (item.modifierName !== null && item.modifierName !== undefined) {
                modifier_option_name = _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2 prod_desc' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title' },
                        item.modifierName
                    )
                );
            }
            return _react3.default.createElement(
                'div',
                { className: 'row cart-item flying-to-cart-holder', style: { backgroundColor: '#fff', borderRadius: '7px' } },
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2 text-center' },
                    _react3.default.createElement(
                        _reactRouter.Link,
                        { to: '/product/' + item.id, className: 'pointer' },
                        _react3.default.createElement('img', { className: 'flying-to-cart-img', src: picture })
                    ),
                    _react3.default.createElement('a', { className: 'close-btn pointer visible-xs', onClick: function onClick(e) {
                            e.preventDefault();
                            _this.props.onDelete(item);
                        } })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/product/' + item.id },
                            item.name
                        )
                    ),
                    _react3.default.createElement(_SHARE.SwitherDescription, { description: item.description })
                ),
                modifier_option_name,
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement(
                        'div',
                        { className: 'price' },
                        _react3.default.createElement(_components2.MoneyValue, {
                            value: price,
                            icon: _this.props.currency.icon,
                            iconAfterValue: _this.props.currency.icon_after_value
                        })
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-4 text-center hidden-xs' },
                    _react3.default.createElement(_components2.AddToBasket, { product: item, style: { marginRight: '3px', marginTop: '5px', marginBottom: '5px', width: '90%' }, count: 1 }),
                    _react3.default.createElement('a', { className: 'close-btn pointer', style: { marginLeft: '5px' }, onClick: function onClick(e) {
                            e.preventDefault();
                            _this.props.onDelete(item);
                        } })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 button_holder' },
                    _react3.default.createElement(_components2.AddToBasket, { id: 'addto-cart', product: item, count: 1 })
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(WishListView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                products = _props.products,
                lang = _props.lang;


            return _react3.default.createElement(
                'section',
                { className: 'user-profile' },
                _react3.default.createElement(
                    'div',
                    { className: 'wishlist' },
                    _react3.default.createElement(
                        'h2',
                        { className: 'section-title' },
                        lang['store.wish_list.wish_list']
                    ),
                    products.length ? _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            'div',
                            { className: 'row no-margin cart-item hidden-xs wish_head' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2 text-center' },
                                lang['store.cart.photo']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2' },
                                lang['store.cart.title']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2' },
                                lang['store.cart.modifiers']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2' },
                                lang['store.cart.price']
                            ),
                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-4' })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'items-holder' },
                            products.map(this.renderProduct)
                        )
                    ) : _react3.default.createElement(
                        'div',
                        { className: 'empty-block' },
                        lang['store.wish_list.empty_wish_list']
                    )
                )
            );
        }
    }]);
    return WishListView;
}(_react2.Component), _class.propTypes = {
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp2));

exports.default = WishListView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/WishList/default/WishListView.jsx
// module id = 1854
// module chunks = 0